import React, { useEffect, useState } from "react";
import { formatLBP } from "../../features/ValueFormater";

const NumberInput = ({
  payload,
  setPayload,
  currency,
  objKey,
  defaultValuee,
  disabled,
  placeholder,
}) => {
  const [formattedNumber, setFormattedNumber] = useState("");

  useEffect(() => {
    setFormattedNumber(
      payload?.[objKey] ? formatNumber(String(payload[objKey])) : "",
    );
  }, [payload?.[objKey]]);
  useEffect(() => {
    setFormattedNumber(currency == 1 ? "$" : "L.L");
  }, [currency]);
  useEffect(() => {
    if (Number(currency) !== 1 && formattedNumber) {
      setFormattedNumber(formatLBP(formattedNumber?.replace(/[^\d.]/g, "")));
    }
  }, [currency]);

  useEffect(() => {
    if (defaultValuee) {
      setFormattedNumber(formatNumber(defaultValuee));
    }
  }, [defaultValuee]);

  const formatNumber = (value) => {
    //if the value is number, then skip formatting
    if (typeof value === "number") return value;

    // Format the number with commas and decimals.
    const parts = value.split(".");
    const formattedInteger = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return parts.length === 2
      ? `${formattedInteger}.${parts[1]}`
      : formattedInteger;
  };
  const handleInputChange = (e) => {
    if (disabled) return;
    const rawValue = e.target.value;
    if (!rawValue) {
      setPayload({
        ...payload,
        [objKey]: null,
      });
      setFormattedNumber(null);
      return;
    }
    const numericValue = rawValue.replace(/[^\d.]/g, "");
    //Remove leading zeros
    const leadingZeroRemoved = numericValue.replace(/^0+/, "");
    // Limit the decimal value to 2 digits after the dot or no dot, in case of currency = 2, then no dot or decimals can be added
    const parts = leadingZeroRemoved.split(".");
    const limitedDecimalValue =
      Number(currency) === 1
        ? parts.length === 2
          ? `${parts[0]}.${parts[1].slice(0, 2)}`
          : parts[0]
        : parts[0];

    setPayload({
      ...payload,
      [objKey]: limitedDecimalValue,
    });

    setFormattedNumber(formatNumber(limitedDecimalValue));
  };

  return (
    <input
      type="text"
      placeholder={
        currency && Number(currency) != 0
          ? currency == 1
            ? "$"
            : "L.L"
          : placeholder || "Amount"
      }
      value={formattedNumber}
      onChange={handleInputChange}
      disabled={disabled}
    />
  );
};

export default NumberInput;
